import React from 'react';
import { useParams } from 'react-router-dom';
import { DetailContainer } from './DetailContainer';
import { ListContainer } from './ListContainer';

export const MobileContainer = () => {
  const { id } = useParams<{ id: string }>() || {};
  if (id) {
    return <DetailContainer id={id} />;
  }
  return <ListContainer />;
};
